import { endsWith, pickBy, keys } from 'lodash'

const login = ({
    email,
    roles,
    userId,
    isShadow,
    scid,
    collegeFeatures,
}) => {
  if (userId) {
    const staff = endsWith(email, '@scoir.com')
    const adminAccount = roles.includes('AdmissionsAdministrator')
    const admissionsOps = roles.includes('AdmissionsOperations')
    const admissionsRep = roles.includes('AdmissionsRepresentative')

    window.aptrinsic(
      'identify',
      {
        id: userId,
        email,
        isShadow: isShadow,
        staff,
        userType: 'AO',
        adminAccount,
        admissionsOps,
        admissionsRep,
        collegeFeatures: keys(pickBy(collegeFeatures)),
      },
      {
        //Account Fields
        id: scid,
      }
    )
  }
}

const gainsight = { login }
export default gainsight
